import { followGoalActionRoute } from '@townsquare/routes/follow-goal-action';

import { FollowGoalAction } from './loadable';
import { followGoalResource } from './resource';

followGoalActionRoute.component = FollowGoalAction;
followGoalActionRoute.resources = [followGoalResource];
export const followGoalActionRouterRoute = followGoalActionRoute;
